import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { ChallengeComputedState } from 'utils/challenges'

interface Props {
  challengeState?: string
}

export default function StatusBadge({ challengeState }: Props): JSX.Element {
  if (challengeState === ChallengeComputedState.LIVE) {
    return (
      <LiveBox>
        <FormattedMessage id="strings.live" />
      </LiveBox>
    )
  }
  if (challengeState === ChallengeComputedState.UPCOMING) {
    return (
      <UpcomingBox>
        <FormattedMessage id="strings.upcoming" />
      </UpcomingBox>
    )
  }
  if (challengeState === ChallengeComputedState.DRAFT) {
    return (
      <DraftBox>
        <FormattedMessage id="strings.draft" />
      </DraftBox>
    )
  }
  if (challengeState === ChallengeComputedState.VISIBLE) {
    return (
      <VisibleBox>
        <FormattedMessage id="sponsoredChallenge.visible" />
      </VisibleBox>
    )
  }
  if (challengeState === ChallengeComputedState.UNPUBLISHED) {
    return (
      <UnpublishedBox>
        <FormattedMessage id="strings.unpublished" />
      </UnpublishedBox>
    )
  }
  return <></>
}

const StatusBox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  min-height: 20px;
  line-height: 1;
  font-size: 14px;
  font-weight: 500;
  border-radius: 16px;
  text-align: center;
  white-space: nowrap;
`

const LiveBox = styled(StatusBox)`
  background: #ceefe0;
  color: #076a3b;
`

const UpcomingBox = styled(StatusBox)`
  background: #ffedd5;
  color: #c2410c;
`

const VisibleBox = styled(StatusBox)`
  background: #e0f2fe;
  color: #0369a1;
`

const DraftBox = styled(StatusBox)`
  background: #f5f5f5;
  color: #404040;
`

const UnpublishedBox = styled(StatusBox)`
  background: #fee2e2;
  color: #b91c1c;
`
